import { AxiosResponse } from 'axios';
import api from '~/services/api';
import { getListProductTechnicalProps } from './product-technical-interface';

class ProductTechnicalService {
  getRawProducts(
    { skip, limit, queryString = '', fieldsToShow = '' },
    opts?: any
  ): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/rawlist', {
      params: {
        skip,
        limit,
        queryString,
        fieldsToShow
      },
      ...opts
    });
  }

  getListProducts(
    { queryString, skip = 0, limit = 100, ...filters }: getListProductTechnicalProps,
    opts: any
  ): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/technical-sheet', {
      params: {
        queryString,
        skip,
        limit,
        ...filters
      },
      ...opts
    });
  }

  getListProductsCount(
    { queryString, ...filters }: getListProductTechnicalProps,
    opts: any
  ): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/technical-sheet?isCount=true', {
      params: {
        queryString,
        ...filters
      },
      ...opts
    });
  }

  saveZipTechnicalData(payload: any): Promise<AxiosResponse<any[] | null>> {
    return api.put('/product/technical-sheet', payload);
  }

  savePdfTechnicalData({ payload, productId }): Promise<AxiosResponse<any[] | null>> {
    return api.put(`/product/technical-sheet/${productId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  saveZipTechnicalDataBatch(payload): Promise<AxiosResponse<any[] | null>> {
    return api.put('/product/technical-sheet', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  deleteItems(productId: string): Promise<AxiosResponse<any[] | null>> {
    return api.delete(`/product/technical-sheet/${productId}`);
  }
}

export default new ProductTechnicalService();
